import React from 'react';
import { gql } from '@common/hooks';
import PropTypes from 'prop-types';
import { ExpiredComplianceBadges } from 'works/legacy/components/expired-compliance-badges';

export function ExpiredComplianceItemsCount({ assignment }) {
  if (!assignment || !assignment.worksList) return null;

  if (assignment.state === 'cancelled' || assignment.state === 'completed') {
    return null;
  }

  return (
    <ExpiredComplianceBadges
      expiredCount={assignment.worksList.expiredItemsCount}
      expiringSoonCount={assignment.worksList.expiringSoonItemsCount}
      pendingVerificationCount={
        assignment.worksList.pendingVerificationItemsCount
      }
    />
  );
}

ExpiredComplianceItemsCount.fragment = gql`
  fragment ExpiredComplianceItemsCountFragment on StaffingRequestAssignment {
    id

    worksList {
      id
      completedItemsCount
      totalItemsCount
      expiringSoonItemsCount
      expiredItemsCount
      pendingVerificationItemsCount
    }
  }
`;

ExpiredComplianceItemsCount.propTypes = {
  assignment: PropTypes.shape({
    id: PropTypes.string.isRequired,
    state: PropTypes.string.isRequired,
    worksList: PropTypes.shape({
      id: PropTypes.string.isRequired,
      expiringSoonItemsCount: PropTypes.number.isRequired,
      expiredItemsCount: PropTypes.number.isRequired,
      pendingVerificationItemsCount: PropTypes.number.isRequired,
    }),
  }),
};
